import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import UISideNavItem from 'UIComponents/nav/UISideNavItem';
import { useSaveFavoriteLesson, useSaveFavoriteTrack } from '../../../components/ContentCards/ReducedContentCard/hooks/useSaveFavoriteContent';
import { CardMenuAction, CardMenuActionLabel } from '../../cardMenu';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UIButton from 'UIComponents/button/UIButton';

const CardMenuWatchLaterOptionBase = ({
  isSaved,
  isRequesting,
  toggleSavedItem,
  render,
  onClick
}) => {
  return /*#__PURE__*/_jsx(UIButton, {
    onClick: () => {
      if (!isRequesting) {
        toggleSavedItem();
        if (onClick) onClick();
      }
    },
    style: {
      width: '100%'
    },
    use: "unstyled",
    children: render( /*#__PURE__*/_jsxs(CardMenuAction, {
      "data-test-id": "watch-later-button",
      children: [/*#__PURE__*/_jsx(CardMenuActionLabel, {
        disabled: isRequesting ? 1 : 0,
        message: isSaved ? 'learningCenter.cardMenu.removeFromWatchLater' : 'learningCenter.cardMenu.addToWatchLater'
      }), isRequesting && /*#__PURE__*/_jsx(UILoadingSpinner, {
        size: "extra-small",
        style: {
          margin: 0
        }
      })]
    }))
  });
};

const TrackCardMenuWatchLaterOption = ({
  trackId,
  render,
  onClick
}) => {
  const [isSaved, toggleSavedItem, isRequesting] = useSaveFavoriteTrack({
    trackId
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(CardMenuWatchLaterOptionBase, {
      isRequesting: isRequesting,
      isSaved: isSaved,
      onClick: onClick,
      render: render,
      toggleSavedItem: toggleSavedItem
    })
  });
};

const LessonCardMenuWatchLaterOption = ({
  lessonId,
  render,
  onClick
}) => {
  const [isSaved, toggleSavedItem, isRequesting] = useSaveFavoriteLesson({
    lessonId
  });
  return /*#__PURE__*/_jsx(CardMenuWatchLaterOptionBase, {
    isRequesting: isRequesting,
    isSaved: isSaved,
    onClick: onClick,
    render: render,
    toggleSavedItem: toggleSavedItem
  });
};

const CardMenuWatchLaterOption = ({
  trackId,
  lessonId,
  render = content => {
    return /*#__PURE__*/_jsx(UISideNavItem, {
      role: "navigation-item",
      title: content
    });
  },
  onClick
}) => {
  if (trackId) return /*#__PURE__*/_jsx(TrackCardMenuWatchLaterOption, {
    onClick: onClick,
    render: render,
    trackId: trackId
  });else if (lessonId) return /*#__PURE__*/_jsx(LessonCardMenuWatchLaterOption, {
    lessonId: lessonId,
    onClick: onClick,
    render: render
  });
  return null;
};

export default CardMenuWatchLaterOption;